// 언어 설정 (빌드 타임 플래그)
//
// 영문 전용 배포 시 .env.production 을 아래처럼 바꾸고 재빌드한다.
//   REACT_APP_DEFAULT_LANG=en
//   REACT_APP_SHOW_LANG_TOGGLE=false
// 되돌릴 때는 ko / true 로 복구 후 재빌드. (자세한 절차: docs/영문전용_배포_계획.md, 2026-10-31 토글 재노출: docs/한국어_재지원_작업이력_2026-10-31.md)

export type Lang = 'ko' | 'en';

// 초기 언어. 미설정 시 한국어.
export const DEFAULT_LANG: Lang = process.env.REACT_APP_DEFAULT_LANG === 'en' ? 'en' : 'ko';

// 헤더/랜딩의 KR·EN 전환 버튼 노출 여부. 'false' 문자열일 때만 숨긴다.
export const SHOW_LANG_TOGGLE = process.env.REACT_APP_SHOW_LANG_TOGGLE !== 'false';
